import { cx } from "classix"
import { HTMLAttributes } from "react"

import "~/shared/assets/icons/font-icons/eios-icons/style.css"

/**
 * Свойства `EiosIcon`
 */
export interface EiosIconProps extends HTMLAttributes<HTMLElement> {
	/** имя иконки */
	name: string
}

/**
 * Иконка из папки `src/assets/icons/font-icons/eios-icons`.
 * @param props
 * @component
 * @category Component
 * @example
 * ```tsx
 * import {EiosIcon} from "~/shared/ui";
 *
 * function Example() {
 *     return (
 *         <EiosIcon name="add" />
 *     );
 * }
 * ```
 */
export function EiosIcon({ name, className, ...props }: EiosIconProps) {
	return (
		<i
			className={cx("eios-icon", `eios-icon-${name}`, className)}
			{...props}
		></i>
	)
}
